import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CustomNavbar from "../../../components/CustomNavbar";
//import SibebarSeleccionContratacion from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import comp from "../../../images/Modulo carrera y sucesion/pngegg.png";
import SidebarNuevaCajas from "../../../components/nueveCajas/SidebarNueveCajas";
import { Link } from "react-router-dom";

const Admin = () => {
  const [show, setShow] = useState(true);
  //* Method
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarNuevaCajas show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="jumbotron ft-banner">
            <main>
              <h1>9 Cajas</h1>
             
              <Row>
                <Col>
                  <h4>Mantenimientos de 9 Cajas</h4>
                  <ul className="ml-3 p-0">

                    <li>
                      <Link to="/matriz-nueve-cajas/matriz">
                        Mantenimiento de matriz de 9 cajas
                      </Link>

                    </li>

                    <li>
                      <Link to="/matriz-nueve-cajas/educacion-formal-metricas">
                        Mantenimiento de métricas de educación formal
                      </Link>

                    </li>

                    <li>
                      <Link to="/matriz-nueve-cajas/metrica-nueve-cajas">
                        Mantenimiento de métrica de 9 cajas
                      </Link>

                    </li>

                    <li>
                      <Link to="/matriz-nueve-cajas/metrica-experiencia-en-puesto">
                        Mantenimiento de metrica de experiencia en puesto
                      </Link>

                    </li>
                  </ul>
                </Col>
              </Row>
            </main>
            <div className="figure">
              <img src={comp} alt="descriptores y perfiles" />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Admin;
